// Hide only when the shipments module is not available
// for this person because of access or installation.
// Show any other failure so it is not mistaken for no linked shipments.
export function hidesLinkedShipments(err) {
  return Boolean(err && (err.status === 403 || err.status === 503));
}
